import { Component, EventEmitter, Inject, LOCALE_ID, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PersonalCodeValidator } from '@ridango/core';

@Component({
    selector: 'rwidget-login-mobileid-form',
    templateUrl: './login-mobileid-form.component.html',
    styleUrls: ['./login-mobileid-form.component.scss']
})
export class LoginMobileidFormComponent implements OnInit {
    loginForm: FormGroup;

    @Output() onLogin = new EventEmitter<any>();

    constructor(
        @Inject('ENV') public env: any,
        @Inject(LOCALE_ID) public locale: string,
        private personalCodeValidator: PersonalCodeValidator
    ) {}

    ngOnInit(): void {
        if (this.locale.length !== 2) {
            this.locale = 'en';
        }

        this.loginForm = new FormGroup({
            phoneNumber: new FormControl('', [Validators.required]),
            personalCode: new FormControl('', [Validators.required, this.personalCodeValidator.getValidator()])
        });
    }

    login() {
        if (this.loginForm.valid) {
            this.onLogin.emit(this.loginForm.value);
        } else {
            this.phoneNumber.markAsTouched();
            this.personalCode.markAsTouched();
        }
    }

    get phoneNumber() {
        return this.loginForm.get('phoneNumber');
    }

    get personalCode() {
        return this.loginForm.get('personalCode');
    }
}
